import { render } from "./SignInEc.vue?vue&type=template&id=3572e398"
import script from "./SignInEc.vue?vue&type=script&lang=ts"
export * from "./SignInEc.vue?vue&type=script&lang=ts"
script.render = render

export default script